const base  =  '/notap'

export const notapUrls = {
    'notap_certificates': `${base}/certificates`,
    // 'dashboard' : '/dashboard',
    // 'certificates' : '/certificates',
    // 'certificates_search' : '/certificates/search',
    'notap_certificates_search' : `${base}/certificates/search`,
    'notap_certificates_view' : `${base}/certificates/view`,
    'notap_transaction_history': `${base}/certificates/:certificateNo/transaction-history`,
    'digitalLetterBase' : `${base}/digital-letters`,
    'digital_letters' : `/:status`,
    'notap_evaluation_history': `${base}/certificates/:certificateNo/evaluation-history`,
    'notap_prev_evaluation_history': `${base}/certificates/:certificateNo/previous-evaluation-history`,
    'notap_letter_history': `${base}/digital-letters/:letterId/evaluation-history`,
    // 'digital_letters' : '/digital-letters',
    // 'user_profile' : '/user-profile',
    // 'print_with_letterhead' : '/official/print',
    // 'print' : '/print',
}